import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Crop169Icon(props: IconProps) {
    return <Icon {...props} iconKey={"crop_16_9"}/>
}
